module.exports = __webpack_public_path__ + "img/grey.312183e.svg";